// PageViewMetric entity related enums

// ---- Event name
export const PageView = {
    // ---- Side content
    ABOUT: 'about',
    PRIVACY: 'privacy',
    LEGALS: 'legals',
    // ---- Main content
    LANDING: 'landing',
    FLASH: 'flash',
    RESULTS: 'results',
    // ---- App content
    BREVET: 'brevet',
    CORRECTION: 'correction',
    GAMES: 'games',
    MULTIPLICATION_GAME: 'multiplication_game',
    RELATIVE_SUM_GAME: 'relative_sum_game'
}